import { Fragment, useCallback, useMemo, useState } from "react"

import { FileThumbnail } from "@molecules/index"

import { FileSidePanel } from "@organisms/index"

function AttachmentRow({ attachments, onSelect }) {
    return (
        <div className="gallery_container">
            {attachments.map(({ attachment, originalIndex }) => (
                <FileThumbnail
                    key={attachment.id || attachment.upload_handle || originalIndex}
                    mimeType={attachment.upload_mimetype}
                    filename={attachment.upload_filename}
                    thumbnailSrc={attachment.thumbnail_url}
                    isInteractive={true}
                    onClick={() => onSelect(originalIndex)}
                />
            ))}
        </div>
    )
}

export default function AttachmentHorizontalDisplay(props) {
    const { attachments: attachmentsProp, attachmentsEndpoint, isPublic } = props

    const [localAttachments, setLocalAttachments] = useState(attachmentsProp)
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false)
    const [selectedAttachmentIndex, setSelectedAttachmentIndex] = useState(0)

    const handleAttachmentDeleted = useCallback((deletedId) => {
        setLocalAttachments((prev) => prev.filter((attachment) => attachment.id !== deletedId))
    }, [])

    const handleAttachmentUpdated = useCallback((attachmentId, updates) => {
        setLocalAttachments((prev) =>
            prev.map((attachment) => (attachment.id === attachmentId ? { ...attachment, ...updates } : attachment)),
        )
    }, [])

    const { publicAttachments, privateAttachments, allAttachments } = useMemo(() => {
        const publicAttachments = []
        const privateAttachments = []
        const allAttachments = []

        localAttachments.forEach((attachment, index) => {
            const entry = { attachment, originalIndex: index }
            allAttachments.push(entry)

            if (attachment.is_public) {
                publicAttachments.push(entry)
            } else {
                privateAttachments.push(entry)
            }
        })

        return { publicAttachments, privateAttachments, allAttachments }
    }, [localAttachments])

    const handleSelect = useCallback((originalIndex) => {
        setSelectedAttachmentIndex(originalIndex)
        setIsSidePanelOpen(true)
    }, [])

    if (localAttachments.length === 0) {
        return null
    }

    const showSections = !isPublic && publicAttachments.length > 0 && privateAttachments.length > 0

    return (
        <Fragment>
            {showSections ? (
                <>
                    <span className="gallery_container__section_label">Public</span>
                    <AttachmentRow attachments={publicAttachments} onSelect={handleSelect} />
                    <span className="gallery_container__section_label">Private</span>
                    <AttachmentRow attachments={privateAttachments} onSelect={handleSelect} />
                </>
            ) : (
                <AttachmentRow attachments={allAttachments} onSelect={handleSelect} />
            )}
            <FileSidePanel
                attachments={localAttachments}
                endpointBase={attachmentsEndpoint}
                initialIndex={selectedAttachmentIndex}
                isPublic={isPublic}
                isOpen={isSidePanelOpen}
                onOpenChange={setIsSidePanelOpen}
                onAttachmentDeleted={handleAttachmentDeleted}
                onAttachmentUpdated={handleAttachmentUpdated}
            />
        </Fragment>
    )
}
